export default __webpack_public_path__ + "static/media/Armguards of the Dark Messenger.790e292b.jpg";